import React from 'react';
import useGame from '../../../../../../hooks/use-game';
import Sentence from './Sentence';
import { FindTheLetterInterface } from '../../../../../../providers/GameProvider/types';
import makeStyles from '@mui/styles/makeStyles';

const FindTheLetterSinglePage: React.FC = () => {
  const classes = useStyles();
  const [{ currentData, activityData }] = useGame<FindTheLetterInterface>();
  const activityLetter = activityData?.book.characters[0].character;
  const pageImage = currentData?.[0]?.png?.src;

  return (
    <div className={classes.wrapper}>
      <img src={pageImage} key={pageImage} />
      <Sentence
        description={currentData?.[0]?.contents?.description}
        pageNumber={currentData?.[0]?.page?.pageNumber}
        activityLetter={activityLetter}
      />
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  wrapper: {
    flex: 1,
    display: 'grid',
    gridTemplateColumns: 'minmax(max-content, 55vw)',
    gridTemplateRows: 'minmax(0,1fr) minmax(5rem, max-content)',
    justifyContent: 'center',
    gridRowGap: '1rem',
    height: '100%',
    maxWidth: '80vw',
    '& img': {
      boxShadow: theme.shadows[3],
      height: 'auto',
      width: 'auto',
      maxHeight: '100%',
      maxWidth: 'max-content',
      alignSelf: 'center',
      justifySelf: 'center',
    },
  },
}));

export default FindTheLetterSinglePage;
